import { Skeleton, Space } from 'antd';

const tabs = ['tab1', 'tab2', 'tab3'];

export const loadingTabItems = tabs.map(i => {
  return {
    key: i,
    label: (
      <Space>
        <Skeleton.Input active size='small' />
      </Space>
    ),
    children: null,
  };
});
